<template>
  <symbol
    id="alert"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 0H14C15.1046 0 16 0.89543 16 2V14C16 15.1046 15.1046 16 14 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0ZM6.93199 8.04694C6.93199 7.45594 7.41199 6.97594 8.00299 6.97594C8.59499 6.97594 9.07499 7.45594 9.07499 8.04694V12.2369C9.06648 12.5155 8.94986 12.7797 8.74984 12.9737C8.54983 13.1677 8.28213 13.2762 8.00349 13.2762C7.72485 13.2762 7.45715 13.1677 7.25714 12.9737C7.05712 12.7797 6.9405 12.5155 6.93199 12.2369V8.04694ZM7.10962 3.05957C7.34629 2.8229 7.66729 2.68994 8.00199 2.68994C8.33669 2.68994 8.65769 2.8229 8.89436 3.05957C9.13103 3.29624 9.26399 3.61724 9.26399 3.95194C9.26399 4.28664 9.13103 4.60764 8.89436 4.84431C8.65769 5.08098 8.33669 5.21394 8.00199 5.21394C7.66729 5.21394 7.34629 5.08098 7.10962 4.84431C6.87295 4.60764 6.73999 4.28664 6.73999 3.95194C6.73999 3.61724 6.87295 3.29624 7.10962 3.05957Z"
    />
  </symbol>
</template>
